export const messages = {
  en: {
    sellingCostDetail: {
      queryCondition: 'Query Conditions',
      sellingCostDetail: 'Selling Cost Details',
      date: 'Date',
      productName: 'Product Name',
      salesRevenue: 'Sales Revenue',
      salesCost: 'Sales Cost',
      grossMargin: 'Gross Margin',
      lossAmount: 'Loss Amount',
      createTime: 'Create Time'
    }
  },
  zh: {
    sellingCostDetail: {
      queryCondition: '查询条件',
      sellingCostDetail: '销售成本明细',
      date: '日期',
      productName: '商品名称',
      salesRevenue: '销售收入',
      salesCost: '销售成本',
      grossMargin: '销售毛利',
      lossAmount: '亏损金额',
      createTime: '创建时间'
    }
  }
}